// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"cdb95162","2209":"c3c937b1","3516":"c3c937b1"}[chunkId] + ".chunk.css";
};